import React, { PureComponent } from 'react';

import {
    View,
    StyleSheet,
    Animated,
    Easing
} from 'react-native'
import {
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib'

import { pt } from '../../common/utils';
import img from '../../common/img';

class Loading extends PureComponent {
    constructor(props) {
        super(props);
        this.state={
            deg:new Animated.Value(0)
        };
        this.animate=this.animate.bind(this);
    }

    render() {
        const {deg}=this.state;
        let trans={
            width: pt(36),
            height: pt(36),
            transform:[
                {
                    rotateZ:deg.interpolate({
                        inputRange: [0, 1],
                        outputRange: ['0deg','360deg']
                    })
                }
            ]
        };
        let { contentStyle, loadingTxt } = this.props;
        return (
            <View style={[st.loading_wrap, contentStyle]}>
                {/*<JDImage source={img.loading}></JDImage>*/}
                <Animated.Image style={trans} source={img.loading}/>
                <JDText style={st.loading_text}>{ loadingTxt || "努力加载中..." }</JDText>
            </View>
        )
    }

    componentDidMount() {
        this.animate();
    }

    animate(){
        this.state.deg.setValue(0);
        Animated.timing(this.state.deg,
            {
                toValue: 1,
                duration: 1500,
                easing: Easing.linear
            }
        ).start(()=>this.animate())
    }
}

const st = StyleSheet.create({
    loading_wrap: {
        alignItems: 'center',
        justifyContent: 'center'
    },
    loading_text: {
        color: '#252525',
        marginTop: pt(8),
        fontSize: pt(13)
    }
})

export default Loading;